import { Box, Skeleton, Button } from '@mui/material';
import CardMenus from './card-menus';
import { useGatewayCardContext } from '../gateway-card.context';
import { useUserProfileQuery } from 'app/store';

const Information: React.FC<{ onClick?: any }> = ({ onClick }) => {
    const { data: profile } = useUserProfileQuery();
    const { loading, gateway } = useGatewayCardContext();
    const { website, title, owner_id, id, access_display_name } = gateway;
    const accessDisplayName = access_display_name?.trim();

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 1,
                minHeight: 44,
            }}>
            <Box
                sx={{
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                }}>
                <Button
                    variant="text"
                    onClick={onClick}
                    disabled={!onClick}
                    sx={{
                        color: 'text.primary',
                        fontSize: 15,
                        fontWeight: '900',
                        maxWidth: '100%',
                        py: 0,
                        px: 0,
                        justifyContent: 'flex-start',
                        wordBreak: 'break-word',
                        '&:disabled': {
                            color: 'text.primary',
                        },
                    }}
                    className="font-yekan-heavy">
                    {loading ? (
                        <Skeleton variant="text" width={120} />
                    ) : (
                        title +
                        (id !== 0 &&
                        profile?.id !== owner_id &&
                        accessDisplayName
                            ? ` (${accessDisplayName})`
                            : '')
                    )}
                </Button>

                <Button
                    size="small"
                    startIcon={
                        <i
                            className="fa-light fa-globe"
                            style={{ fontSize: '13px' }}></i>
                    }
                    variant="text"
                    onClick={onClick}
                    disabled={!onClick}
                    sx={{
                        color: 'text.secondary',
                        fontSize: 12,
                        fontWeight: '400',
                        maxWidth: '100%',
                        py: 0,
                        px: 0,
                        mt: 0.5,
                        justifyContent: 'flex-start',
                        wordBreak: 'break-word',
                        '&:disabled': {
                            color: 'text.secondary',
                        },
                        '& .MuiButton-startIcon': {
                            margin: 0,
                            marginInlineEnd: '6px',
                            color: 'text.light',
                        },
                    }}>
                    {loading ? (
                        <Skeleton
                            variant="text"
                            sx={{ width: '40%', fontSize: '1rem' }}
                        />
                    ) : (
                        website
                    )}
                </Button>
            </Box>

            <CardMenus />
        </Box>
    );
};

export default Information;
